export const ASSETS = {
  logo: "/logo-lm-icon.png",
  louisHero: "https://customer-assets.emergentagent.com/job_69e7ae2c-dd5a-4f63-8082-513ca0b39f17/artifacts/mllr9i4z_prof_LM.jpeg",
  weddingHero: "https://images.unsplash.com/photo-1633978555421-1e67d524b227?crop=entropy&cs=srgb&fm=jpg&q=85",
  ballroomBg: "https://images.unsplash.com/photo-1574281160075-6eb5f7bfe645?crop=entropy&cs=srgb&fm=jpg&q=85",
};
